/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";
import ContentLayoutAddNewAssets from "../contentLayoutAddNewAssets";
import ContentLayoutManageContents from "../contentLayoutManageContents";
import PlaylistLayout from "../playlistLayout";
import DomainLayout from "../domainLayout";
import HelpCenterInfoPage from "../helpCenterInfoPage";
import CalendarLayout from "../calendarLayout";
import CampaignLayoutCampaignContent from "../CampaignLayoutCampaignContent";
import CampaignLayoutManageContent from "../CampaignLayoutManageContent";
import NetworkHelpCenter from "../networkHelp";
import FAQ from "../FAQ";
import CommonRequest from "../commonRequest";

export const DomainModule = () => (
  <HelpCenterInfoPage body={<DomainLayout />} />
);

export const ContentAddModule = () => (
  <HelpCenterInfoPage body={<ContentLayoutAddNewAssets />} />
);

export const ContentManageModule = () => (
  <HelpCenterInfoPage body={<ContentLayoutManageContents />} />
);

export const PlaylistModule = () => (
  <HelpCenterInfoPage body={<PlaylistLayout />} />
);

export const CampaignContentModule = () => (
  <HelpCenterInfoPage body={<CampaignLayoutCampaignContent />} />
);
export const CampaignManageModule = () => (
  <HelpCenterInfoPage body={<CampaignLayoutManageContent />} />
);

export const CalendarModule = () => (
  <HelpCenterInfoPage body={<CalendarLayout />} />
);

export const NetworkModule = () => (
  <HelpCenterInfoPage body={<NetworkHelpCenter />} />
);

export const FAQModule = () => <HelpCenterInfoPage body={<FAQ />} />;

export const CommonRequestsModule = () => (
  <HelpCenterInfoPage body={<CommonRequest />} />
);
